import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { RequirementContextType } from "../types";
import { WSPillProps } from "@wingspanhq/fe-component-library";
import { selectorIsRequirementPostApproval } from "../selectors/selectorIsRequirementPostApproval";
import { selectorIsRequirementExpiringSoon } from "../selectors/selectorIsRequirementExpiringSoon";
import { selectorIsRequirementArchived } from "../selectors/selectorIsRequirementArchived";

export const extendRequirementStatusPill = (
  requirement: IRequirementResponse,
  requirementContextType: RequirementContextType,
  originalPill: WSPillProps
): WSPillProps => {
  const isReadyForApprove =
    requirement.status === RequirementStatus.PendingReview;

  const isExpiringSoon = selectorIsRequirementExpiringSoon(requirement);

  const isPostApproval = selectorIsRequirementPostApproval(requirement);

  const isArchived = selectorIsRequirementArchived(requirement);

  if (isArchived) {
    return {
      theme: "neutral",
      text: "Archived",
      icon: "archive"
    };
  }

  if (
    isExpiringSoon &&
    requirementContextType === RequirementContextType.Payer
  ) {
    return {
      theme: "warning",
      text: "Action required",
      icon: "time"
    };
  }

  if (isReadyForApprove) {
    if (requirementContextType === RequirementContextType.Payee) {
      return {
        theme: "warning",
        text: "Action required",
        icon: true
      };
    } else {
      return {
        theme: "neutral",
        text: "Awaiting client",
        icon: "time"
      };
    }
  } else if (isPostApproval) {
    if (requirement.status === RequirementStatus.Complete) {
      return {
        theme: "success",
        text: "Complete",
        icon: true
      };
    } else {
      return {
        theme: "error",
        text: "Rejected",
        icon: true
      };
    }
  }

  return originalPill;
};
